import { useTranslation } from 'react-i18next';
import { S, DataCard } from '../../regureStyles';
import { useFeature } from '../../../hooks/useAccess';

const PortfolioSummary = ({ b }) => {
  const { t } = useTranslation();
  // Commission Plan is a commissions-module fact. On a tenant without the
  // module it could only ever render an em dash, which reads as "this sponsor
  // has no commission plan" rather than "this tenant does not run commissions".
  // Same rule, and the same hook, as the nav and the routes.
  const commissionsEnabled = useFeature('commissions');

  const metrics = [
    {
      label: t('screens.brokers.portfolioActivePolicies', { defaultValue: 'Active Policies' }),
      // Computed by the backend from the Policy collection. It used to read a
      // denormalised `Broker.activePolicies` that nothing ever wrote, so every
      // sponsor rendered 0 — MOK's Iberia showed 0 directly above an Associated
      // Clients table listing its 2 policies.
      //
      // `== null` distinguishes "not supplied" from a genuine zero: a sponsor
      // with no active policies must still read 0, and only a missing value
      // renders as an em dash.
      value: b.activePolicies == null ? '—' : b.activePolicies,
      color: S.textPrimary,
    },
    ...(commissionsEnabled
      ? [{
        label: t('screens.brokers.portfolioCommPlan', { defaultValue: 'Commission Plan' }),
        value: b.commPlan || '—',
        color: S.burgundy,
      }]
      : []),
    {
      label: t('screens.brokers.portfolioLossRatio', { defaultValue: 'Loss Ratio' }),
      value: `${b.lossRatio || 0}%`,
      color: (b.lossRatio || 0) < 50 ? '#10b981' : (b.lossRatio || 0) < 65 ? '#f59e0b' : '#ef4444',
    },
    {
      label: t('screens.brokers.portfolioClientSince', { defaultValue: 'Client Since' }),
      value: b.sinceDate ? new Date(b.sinceDate).getFullYear() : '—',
      color: S.textPrimary,
    },
  ];

  return (
    <DataCard>
      <div style={{ fontSize: 14, fontWeight: 700, color: S.textPrimary, marginBottom: 14 }}>{t('screens.brokers.portfolioSummaryTitle', { defaultValue: 'Portfolio Summary' })}</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
        {metrics.map(m => (
          <div key={m.label}>
            <div style={{ fontSize: 11, color: S.textMuted, fontWeight: 600, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 4 }}>{m.label}</div>
            <div style={{ fontSize: 16, fontWeight: 700, color: m.color }}>{m.value}</div>
          </div>
        ))}
      </div>
    </DataCard>
  );
};

export default PortfolioSummary;
